import { render, staticRenderFns } from "./booksDetail.vue?vue&type=template&id=34128410&"
import script from "./booksDetail.vue?vue&type=script&lang=js&"
export * from "./booksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports